module.exports = __webpack_public_path__ + "img/default-image.33bae46d.png";